import { CfAsset } from '../asset';

export function mapCfEntityToCfProductAccessory(cfEntity = {}) {
    const { fields } = cfEntity;
    const { name, label, image } = fields || {};
    return {
        name,
        label,
        image: image && CfAsset.mapCfEntity(image),
    };
}
